// @ts-strict-ignore
import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Directive,
  ElementRef,
  HostBinding,
  HostListener,
  Input, OnDestroy, OnInit,
  ViewChild
} from '@angular/core';
import { LMFieldBaseComponent } from '@field/lm-field-base.component';
import { LMModel, LMModelChangedEvent } from '@form/model';
import { SohoDropDownComponent } from 'ids-enterprise-ng';
import { LMFormRequestService } from '@form/services';
import { LMFieldServiceAdapter } from '@field/lm-field-service-adapter';
import * as urltemplate from 'url-template';
import { LMLayoutType } from '@field/services/lm-field-layout.service';
import { AppConstants } from '@utils/app.constants';
import { Observable } from 'rxjs/internal/Observable';
import TriggeredEvent = JQuery.TriggeredEvent;
import { LMAdHocSelectedField } from '@app/components';

export enum LMDropDownDisplayTypeEnum {
  PLAIN = 0,
  USER_DEFINED,
  MULTI,
  TEXT,
  BOOLEAN,
  TAG
}

@Directive()
export abstract class LMDropdownBaseComponent extends LMFieldBaseComponent implements  OnInit, AfterViewChecked, AfterViewInit, OnDestroy {
  @ViewChild(SohoDropDownComponent) dropdown: SohoDropDownComponent;

  @Input() layoutObject: LMDropdownLayout;
  @Input() specFields: LMSpecFields;
  @Input() model: LMModel;

  private callMarkForCheckOnDropdown = false;

  @HostListener('keyup', [ '$event' ]) onKeyUp(event) {
    if (event.which === 13 && event.target.nodeName !== 'BUTTON') {
      event.stopPropagation();
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  }

  @HostBinding('class.keyfield-multi-select') keyMultiSelectClass = false;

  @HostBinding('class.lm-dropdown-is-tag') classDropDownIsTag = false;

  @HostBinding('attr.data-automation-id') dataFieldAutomationId = '';

  // @HostBinding('attributes') dropdownAttributes: SohoAttributesArray;
  public dropdownAttributes: SohoAttributesArray = [];

  public isMultiSelect = false;
  public isUserDefined: boolean;
  public displayAsDropdown: boolean;

  /**
   * valid only for BusFormFields with display as dropdown
   */
  public useStartsWithFilterOp = false;

  public isBoolean = false;
  public showDropDownDirtyIndicator = false;
  public userDefinedReloadType: SohoDropDownReloadStyles;

  public displayType: LMDropDownDisplayTypeEnum;
  public layoutDisplayType;

  public maxSelected: number;
  public showUserDefinedAsMulti = false;
  // public showSelectAll: boolean;

  public staticDisplayValues: LMStateValue[];

  // Show extra messages in multi select
  public extraMessages = true;

  // Drodpown shows only states as defined in LPL "Allowed States"
  public hasLimitedStates = false;

  protected constructor(
    protected changeDetectorRef: ChangeDetectorRef,
    protected lmFormRequestService: LMFormRequestService,
    protected lmFieldServiceAdapter: LMFieldServiceAdapter,
    protected element: ElementRef
  ) {
    super(lmFieldServiceAdapter);
    this.layoutDisplayType = LMDropDownDisplayTypeEnum;
  }

  // events
  ngOnInit() {
    if (this.lmFieldServiceAdapter.lmLoggerService.cskLog === 2) {
      this.lmFieldServiceAdapter.lmLoggerService.time({
        id: `Total-Dropdown-${this.instanceId}`,
        description: 'TOTAL DROPDOWN',
        functionName: 'ngOnInit()',
        className: 'LMDropdownComponent',
        timingStart: 'LmDropdownComponent -> ngOnInit()',
        timingEnd: 'LmDropdownComponent -> ngAfterViewInit()',
        fieldType: this.layoutObject.type
      });
    }

    super.ngOnInit();
    this.initialize(this.layoutObject, this.specFields, this.model);

    if (this.layoutType === LMLayoutType.MULTI_SELECT) {
      this.isMultiSelect = true;
    }

    /**
     * treat displayAsDropdown as user defined states. All the logic for retrieving data,
     * building the state objects, etc... is the same.
     */
    this.isUserDefined = this.specField?.hasUserDefinedStates || this.layoutObject.displayAsDropdown;
    this.displayAsDropdown = this.layoutObject.displayAsDropdown;
    this.useStartsWithFilterOp = this.layoutObject.useStartsWithFilterOp;
    this.isBoolean = this.onSearchForm && this.specField?.type === AppConstants.BOOLEAN;
    this.hasLimitedStates = this.layoutObject?.limitedStates?.length > 0;

    // if (this.updateDropDownStates()) {
    //   this.updateStateForValue();
    // }

    // This is need when we use a filter and then want to refine the search
    // if (this.onSearchForm && this.isUserDefined && !this.modelField.isBlank) {
    //   // need to get the states because the search field has a value.
    //   this.prepareUserDefinedRequest('').subscribe({
    //     next: (result: LMUserDefinedResponse) => {
    //       this.handleUserDefinedResponse(result);
    //
    //       // reflect the changes made to modelField.states
    //       // Using changeDetectorRef directly vs using lmFieldServiceAdapter.changeDetectorRef
    //       // since that did not work
    //       this.changeDetectorRef.markForCheck();
    //     },
    //     error: (error) => {
    //       this.lmFieldServiceAdapter.lmLoggerService.error([ 'Error in getUserDefinedStates', this.bindId, error ]);
    //     }
    //   });
    // }

    if (this.lmFieldServiceAdapter.lmContextService.userDefinedStatesPageSizeAndIndicator()) {
      this.userDefinedReloadType = 'typeahead';
    } else {
      this.userDefinedReloadType = 'open';
    }

    if (!this.onSearchForm) {
      if (!(this.displayAsText || this.displayAsTag)) {
        this.subscribeToInlineError();
      }

      if (this.displayAsTag) {
        this.displayType = this.layoutDisplayType.TAG;

      } else if (!this.displayAsText && this.isMultiSelect) {
        this.displayType = this.layoutDisplayType.MULTI;
        if (this.modelField.isKeyFieldMultiselect) {
          this.maxSelected = null;

        } else {
          this.maxSelected = this.modelField.maxSelected;

        }
      } else if (!this.displayAsText && this.isUserDefined) {
        this.displayType = this.layoutDisplayType.USER_DEFINED;

      } else if (!this.displayAsText) {
        this.displayType = this.layoutDisplayType.PLAIN;

      } else if (this.displayAsText && !this.isCompoundFieldMember) {
        this.displayType = this.layoutDisplayType.TEXT;
      }

      this.subscriptionArray.push(this.model.modelChanged
        .subscribe((modelChangedEvent: LMModelChangedEvent) => {
          if (modelChangedEvent.eventType === 'update') {
            // LMCLIENT-35595: Special case update required?
            if (this.updateDropDownStates()) {
              this.updateStateForValue();
            }
            // else if (this.usewc) {
              // don't like this but have to have it.
              // When a 'when value when changed' returns
              // a blank value for the target dropdown field
              // the ui gets updated with the blank value.
            //   this.updateComponentDisplay();
            // }
            // if (this.updateDropDownStates()) {
            //   const value = (typeof this.modelField.value === 'number') ? this.modelField.value.toString(10) : this.modelField.value;
            //   this.prepareUserDefinedRequest(value, undefined, true)
            //   // this.prepareUserDefinedRequest('', -1)
            //     .subscribe((result: LMUserDefinedResponse) => {
            //       const aryOptions = this.handleUserDefinedResponse(result);
            //       // eslint-disable-next-line eqeqeq
            //       const found = aryOptions.find(v => v.value == this.modelField.value);
            //       if (!found) {
            //         this.modelField.states.push({ value: String(this.modelField.value), label: String(this.modelField.value) });
            //       }
            //
            //       if (this.dropdown) {
            //         this.dropdown.markForRefresh();
            //       } else if (this.displayAsText) {
            //         this.modelField.valueChanged.next(this.modelField.value);
            //       }
            //     });
            // }
          } else if (modelChangedEvent.eventType === 'set' && this.isUserDefined && this.modelField.states?.length > 0 && this.isReadOnly) {
            // a save action has occurred, and a readonly user defined states now has a value. The states are built
            // correctly in lm-field-base.component, but we need to mark the control for refresh to the value
            // appears correctly. This is for https://jira.infor.com/browse/LMWEB-19157
            this.dropdown?.markForRefresh();
          } else if (modelChangedEvent.eventType === 'set' && this.hasLimitedStates) {
            this.addValueToLimitedStates();
          }
        })
      );
    } else {
      if (this.specField.isBusClassContextField) {
        this.displayType = this.layoutDisplayType.BOOLEAN;

      } else if (this.model.isCubeSearchForm) {
        // Override the type since cube does not support multi-search yet. The model states will include a blank value.
        // Boolean does not add multiple attribute to drop down. Plain also has multiple attribute set.
        this.displayType = this.layoutDisplayType.BOOLEAN;

      } else if (this.isMultiSelect) {
        this.displayType = this.layoutDisplayType.MULTI;

      } else if (this.isBoolean) {
        this.displayType = this.layoutDisplayType.BOOLEAN;

      } else if (this.isUserDefined) {
        this.displayType = this.layoutDisplayType.USER_DEFINED;
        this.showUserDefinedAsMulti = this.lmFieldServiceAdapter.lmContextService.enableMultipleSearchTerms();

      } else {
        this.displayType = this.layoutDisplayType.PLAIN;

      }
    }

    this.setSize();
    const size = (this.isUserDefined) ? this.specField.size + 2 : this.size;

    // a boolean field does not have a size attribute, so make the dropdown small
    if (this.displayType === this.layoutDisplayType.BOOLEAN) {
      this._fieldClassArray.push('dropdown-xs');
    }

    this.setFieldClasses(size);

    this.keyMultiSelectClass = this.modelField && this.modelField.isKeyFieldMultiselect;
    this.classDropDownIsTag = this.displayAsTag;
    this.dataFieldAutomationId = `lm-${this.fieldAutomationId}-field`;
    this.fieldIdAttributes.push({ name: 'aria-describedby', value: this.fieldDescriptionId });

    if (this.displayType === LMDropDownDisplayTypeEnum.PLAIN && this.layoutObject.limitedStates?.length > 0) {
      // limited states for this dropdown, only display what is on the layout object
      this.staticDisplayValues = this.layoutObject.limitedStates;
      this.addValueToLimitedStates();
      if (this.onSearchForm) {
        const tempStateValues = this.staticDisplayValues;

        // Change blank entries to Not Entered when on a search form
        // using non-strict equality to evaluate 0, '0', 0.00, '0.00' as zero, etc
        // eslint-disable-next-line eqeqeq
        if ((tempStateValues[0].value == 0 && tempStateValues[0].label.trim() === '') ||
          tempStateValues[0].value === ' ') {
          tempStateValues[0].value = 'Not Entered';
          tempStateValues[0].label = Soho.Locale.translate('ListStaticFieldFilterNotEntered');
        }

        this.staticDisplayValues = tempStateValues;
      }
    } else {
      this.staticDisplayValues = this.modelField.states;
    }
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.doAfterViewInitStuff();
    if (this.lmFieldServiceAdapter?.lmLoggerService?.cskLog === 2) {
      this.lmFieldServiceAdapter.lmLoggerService.timeEnd(`Total-Dropdown-${this.instanceId}`);
    }
  }

  public abstract doAfterViewInitStuff(): void;

  ngAfterViewChecked() {
    super.ngAfterViewChecked();
    this.doAfterViewCheckedStuff();
  }

  doAfterViewCheckedStuff() {
    if (this.callMarkForCheckOnDropdown && this.dropdown) {
      this.callMarkForCheckOnDropdown = false;
      setTimeout(() => {
        this.dropdown.markForRefresh();
      });
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  onAfterResetDirty(event: SohoTrackDirtyEvent) {
    // only reset dirty to pristine on change if already dirty
    if (this.isDirty) {
      if (this.isCompoundFieldMember && !this.isPreviewCompoundMember) {
        this.showDropDownDirtyIndicator = false;
      }
    }
    super.onAfterResetDirty(event);
  }

  onDirty(event: SohoTrackDirtyEvent) {
    // only set dirty if not already dirty
    if (!this.isDirty) {
      if (this.isCompoundFieldMember && !this.isPreviewCompoundMember) {
        this.showDropDownDirtyIndicator = true;
      }
    }
    super.onDirty(event);
  }

  onPristine(event: SohoTrackDirtyEvent) {
    // only set pristine if already dirty
    if (this.isDirty) {
      if (this.isCompoundFieldMember && !this.isPreviewCompoundMember) {
        this.showDropDownDirtyIndicator = false;
      }
    }
    super.onPristine(event);
  }

  // sohoxi control event; user has interacted with the field and made a selection
  public onChanged(event: TriggeredEvent) {
    this.onChange();

    if (event && this.dropdown) {
      this.doHandleOnFieldChangedForDropdown = true;
    }
  }

  compareWithFn = (value: string, selectedValue: number | string) =>
    // using non-strict equality to evaluate 0, '0', 0.00, '0.00' as zero
    // LMWEB-16402: this would also satisfy 1 == '1'
    // eslint-disable-next-line eqeqeq
    value == selectedValue;


  source = (response: any, searchTerm: string) => {
    this.busyIndicator = true;

    this.prepareUserDefinedRequest(searchTerm)
      .subscribe((result: LMUserDefinedResponse) => {
          const optionsAry = this.handleUserDefinedResponse(result);
          setTimeout(() => {
            if (typeof response === 'function') {
              // true indicates to sohoxi dropdown to not create option tags
              response(optionsAry, true);
            } else {
              // LMCLIENT-23932: need to call updated() in this case
              this.dropdown.updated();
            }

            this.busyIndicator = false;
          }, 1);

          return;
        },
        (error) => {
          this.busyIndicator = false;
          this.lmFieldServiceAdapter.lmLoggerService.error([ 'Error in getUserDefinedStates', this.bindId, error ]);
        });
  };

  private buildFilterCriteriaQueryString(filterCriteria: Array<LMFilterFieldCriteria>): string {
    // set filter criteria on the url params
    if (filterCriteria) {
      const filterParamString = this.lmFieldServiceAdapter.lmUrlUtilService.filterFieldCriteriaToUrlParams(filterCriteria, 'fc');
      if (filterParamString) {
        return filterParamString;
      }
    }
    return '';
  }

  prepareUserDefinedRequest(searchTerm: string | Array<string>, forcedPageSize?: number, getStateForValue = false): Observable<LMUserDefinedResponse> {
    // const selectFieldId = this.specField.selectFieldId;
    const selectFieldId = (this.isMultiSelect && !this.modelField.isKeyFieldMultiselect)
      ? this.specField.selectFieldId // change this with LMCLIENT-34628, don't need to send in something like Races.Race[1], should only send in Races.Race this.modelField.members[ 0 ]
      : this.bindId;

    const formUrlInfo = this.model.formUrlInfo;
    const compiledFormRequestUrl = formUrlInfo.formRequestUrl ? urltemplate.parse(formUrlInfo.formRequestUrl) : '';
    let formRequestUrl = (compiledFormRequestUrl) ? compiledFormRequestUrl.expand({ resourceId: this.model.formResourceId, onSearchForm: this.model.isSearchForm }) : '';
    let pageSize: number;

    if (forcedPageSize !== undefined) {
      pageSize = forcedPageSize;
    } else if (this.lmFieldServiceAdapter.lmContextService.userDefinedStatesPageSizeAndIndicator()) {
      if (getStateForValue) {
        const filterCriteria: LMFilterFieldCriteria[] = [ {
          operator: 'equals',
          fieldId: selectFieldId,
          value: searchTerm as any,
        } ];

        // could be a case where there are no other csks on the url, so will have to use ? as the delimiter instead of &
        formRequestUrl = this.lmFieldServiceAdapter.lmUrlUtilService.addParamToUrl(formRequestUrl, 'getStateForValue', 'true');
        const delimiter = (formRequestUrl.indexOf('?') > -1) ? '&' : '?';
        formRequestUrl += delimiter + this.buildFilterCriteriaQueryString(filterCriteria);
      } else if (searchTerm && searchTerm.length > 0) {
        const operator = this.displayAsDropdown && this.useStartsWithFilterOp ? 'startsWith' : 'contains';

        const filterCriteria: LMFilterFieldCriteria = {
          operator,
          fieldId: selectFieldId,
          value: searchTerm as string,
        };

        // could be a case where there are no other csks on the url, so will have to use ? as the delimiter instead of &
        const delimiter = (formRequestUrl.indexOf('?') > -1) ? '&' : '?';
        formRequestUrl += delimiter + this.buildFilterCriteriaQueryString([ filterCriteria ]);
      }
      if (this.model.isSearchForm) 
        formRequestUrl = this.lmFieldServiceAdapter.lmUrlUtilService.addParamToUrl(formRequestUrl, 'searchform', 'true');
      
      pageSize = this.lmFieldServiceAdapter.lmContextService.userDefinedStatesDefaultPageSize();
    }

    let adhocFields: LMAdHocSelectedField[] = null;
    if (this.layoutInfo?.isAdHoc) {
      formRequestUrl = this.lmFieldServiceAdapter.lmUrlUtilService.addParamToUrl(formRequestUrl, 'adhocSearchField', 'true');
      adhocFields = this.model.getAdhocSearchFieldIds();
    }

    const dataView: LMDataView = this.getSearchFormValidatedDataView();
    const actionName = this.model.action;
    return this.lmFormRequestService.getUserDefinedStates(
      formRequestUrl, selectFieldId, dataView, actionName, pageSize, this.layoutObject.selectListInfo, adhocFields);
  }

  handleUserDefinedResponse(result: LMUserDefinedResponse, getStateForValue = false): Array<LMStateValue> {
    let optionsAry: Array<LMStateValue>;
    if (this.lmFieldServiceAdapter.lmContextService.userDefinedStatesPageSizeAndIndicator()) {
      if (result && result.hasOwnProperty('states') && Array.isArray(result.states)) {

        // Need to ensure that a selected value is in the options, even if it wasn't returned from the server call
        if (!this.modelField.isBlank) {
          // On a search form the value for the dropdown can be an array (multiple selections).
          // this.isMultiSelect is not true here. That is reserved for regular form multi select dropdowns.
          if (!this.isMultiSelect && !Array.isArray(this.modelField.value)) {
            // tslint:disable-next-line:triple-equals > using non-strict equality to evaluate 0, '0', 0.00, '0.00' as zero, etc
            // eslint-disable-next-line eqeqeq
            if (!result.states.some((value: LMStateValue) => value.value == this.modelField.value)) {
              if (this.modelField.states) {
                // have a selected value that isn't in the results array. Add it back in from the current modelField.state
                // triple-equals > using non-strict equality to evaluate 0, '0', 0.00, '0.00' as zero, etc
                // eslint-disable-next-line eqeqeq
                const selectedValue = this.modelField.states.filter((mfState: LMStateValue) => mfState.value == this.modelField.value);
                result.states = [ ...result.states, ...selectedValue ];
              }
            }
          } else {
            // multiselect case
            if (Array.isArray(this.modelField.value)) {

              const len = this.modelField.value.length;
              let selectedValues: Array<LMStateValue> = [];

              for (let i = 0; i < len; i++) {
                const selectedValue = this.modelField.value[i];
                if (selectedValue === 'Not Entered') {
                  continue;
                }

                // using non-strict equality to evaluate 0, '0', 0.00, '0.00' as zero, etc
                // eslint-disable-next-line eqeqeq
                const selectedStateValue = this.modelField.states?.find((mfState: LMStateValue) => mfState.value == selectedValue);

                // have a selected value that isn't in the results array. Add it back in from the current modelField.state
                // triple-equals > using non-strict equality to evaluate 0, '0', 0.00, '0.00' as zero, etc
                // eslint-disable-next-line eqeqeq
                if (selectedStateValue && !result.states.some((resultValue: LMStateValue) => resultValue.value == selectedStateValue.value)) {
                  selectedValues = [ ...selectedValues, selectedStateValue ];
                }
              }

              result.states = [ ...result.states, ...selectedValues ];
            }
          }
        }

        if (this.isMultiSelect || (this.onSearchForm && !this.isUserDefined)) {
          optionsAry = this.lmFieldServiceAdapter.lmFormatUtilService.fieldStatesToMultiOptionsArray(result.states, this.modelField.value);

        } else {
          // need to format the zero value for BCD and PERCENT types as they need to match
          // the dataView field value for the track dirty processing to work correctly.
          // see also ViewBuilderBase.java > fieldAttributeToJsonObject()
          // and JSONConverter.java > fieldStateArrayForFieldValueNg()
          // and lm-model-field
          // using precision here as that is the property available for a state
          const zeroOrBlankValue = this.lmFieldServiceAdapter.lmFormatUtilService.fieldStateFormatZeroValue(this.specField.type, this.modelField.precision);
          const displayNoValue = this.onSearchForm && (this.specField.type === 'ALPHA' || this.specField.type === 'ALPHAUPPER' || this.specField.type === 'ALPHALOWER');
          let addBlankEntry = true;
          if (this.onSearchForm && this.layoutObject.displayAsDropdown) {
            addBlankEntry = false;
          }
          if (getStateForValue) {
            // don't need a blank entry when getting a single value to display
            // in the dropdown. When bringing up the dropdown list then adding blank
            // value is required for isUserDefined dropdowns.
            addBlankEntry = false;
          }
          optionsAry = this.lmFieldServiceAdapter.lmFormatUtilService.fieldStatesToOptionsArray(result.states, addBlankEntry, zeroOrBlankValue, this.isUserDefined, displayNoValue);
        }

        // TODO: This appears to be absent in web components.
        // Adding flag ("extraMessages") to skip for now
        const extraMessages: Array<LMStateValue> = [];

        if (this.isMultiSelect && this.extraMessages && !this.modelField.isKeyFieldMultiselect) {
          const selectMore: LMStateValue = {
            value: 'NANSelection',
            label: this.lmFieldServiceAdapter.lmFormatUtilService.formatMessage(Soho.Locale.translate('NumberSelected'), [ this.modelField.value.length, this.modelField.maxSelected ]),
            disabled: true
          };

          extraMessages.push(selectMore);
        }

        if (result.hasMore && this.extraMessages) {
          const searchToRefine: LMStateValue = {
            value: 'NANSearch',
            label: Soho.Locale.translate('RefineSearch'),
            disabled: true
          };

          extraMessages.push(searchToRefine);
          // this.modelField.states = [ ...optionsAry, searchToRefine];
        }

        this.modelField.states = [ ...optionsAry, ...extraMessages ];
      } else {
        // an error
        this.busyIndicator = false;
        this.lmFieldServiceAdapter.lmLoggerService.error([ 'Error in getUserDefinedStates', this.bindId, result ]);
      }
    } else {
      if (Array.isArray(result)) {
        if (this.isMultiSelect || (this.onSearchForm && this.isUserDefined)) {
          optionsAry = this.lmFieldServiceAdapter.lmFormatUtilService.fieldStatesToMultiOptionsArray(result, this.modelField.value);

        } else {
          // need to format the zero value for BCD and PERCENT types as they need to match
          // the dataView field value for the track dirty processing to work correctly.
          // see also ViewBuilderBase.java > fieldAttributeToJsonObject()
          // and JSONConverter.java > fieldStateArrayForFieldValueNg()
          // and lm-model-field
          // using precision here as that is the property available for a state
          const zeroOrBlankValue = this.lmFieldServiceAdapter.lmFormatUtilService.fieldStateFormatZeroValue(this.specField.type, this.modelField.precision);
          optionsAry = this.lmFieldServiceAdapter.lmFormatUtilService.fieldStatesToOptionsArray(result, true, zeroOrBlankValue, this.isUserDefined);
        }

        this.modelField.states = optionsAry;
      } else {
        // an error
        this.busyIndicator = false;
        this.lmFieldServiceAdapter.lmLoggerService.error([ 'Error in getUserDefinedStates', this.bindId, result ]);
      }
    }
    return optionsAry;
  }

  updateDropDownStates(): boolean {
    // The user will not be able to click on the field to retrieve user defined states.
    // But an initial value / oto rule may come back with data. Fetch the states and update the control to display the value.
    // Also needed for a when value changed is run for user defined state when no initial value is set
    if (this.isUserDefined && !this.modelField.isBlank) {
      if (this.modelField.states === undefined || this.modelField.states.length === 0) {
        // no states
        return true;
      }
      const state = this.modelField.states.find((state: LMStateValue) => this.modelField.value === state.value);
      if (!state) {   // if no state is found for the value then return true so the state is retrieved.
        return true;
      }
    }
    return false;
  }

  contextMenuClicked = ($event) => {
    this.onContextMenuEvent($event);
  };

  trackByValue(index: number, state: LMStateValue) {
    return state.value;
  }

  onBlur(event) {
    super.onBlur(event);
  }

  onModelChanged(value) {
    this.modelField.value = value;
  }

  private addValueToLimitedStates(): void {
    if (!this.lmFieldServiceAdapter.lmFieldUtilService.isBlank(this.specField.type, this.modelField.value)) {
      // value set on the field, make sure it is in the limited states array
      if (!this.staticDisplayValues.find((state: LMStateValue) => state.value == this.modelField.value)) {
        const state: LMStateValue = this.modelField.states.filter((state: LMStateValue) => state.value == this.modelField.value)[0];
        if (state)
          this.staticDisplayValues.unshift(state);
      }
    }
  }

  updateStateForValue() {
    // if (this.displayAsDropdown && !this.modelField.isBlank) {
    const value = (typeof this.modelField.value === 'number') ? this.modelField.value.toString(10) : this.modelField.value;
    this.prepareUserDefinedRequest(value, undefined, true).subscribe({
      next: (result: LMUserDefinedResponse) => {
        const aryOptions = this.handleUserDefinedResponse(result, true);

        // eslint-disable-next-line eqeqeq
        if (this.onSearchForm) {
          // todo need to tdo this differently for multi select in case the modelfield.value is an
          //  array of selected values.
          const found = aryOptions.find(v => v.value == this.modelField.value);
          if (!found) {
            this.modelField.states.push({ value: String(this.modelField.value), label: String(this.modelField.value), selected: true });
          }
        }

        if (this.displayAsText || this.displayAsTag) {
          this.modelField.valueChanged.next(this.modelField.value);
        } else {
          // reflect the changes made to modelField.states
          // Using changeDetectorRef directly vs using lmFieldServiceAdapter.changeDetectorRef
          // since that did not work
          this.updateComponentDisplay();
        }
      },
      error: (error) => {
        this.lmFieldServiceAdapter.lmLoggerService.error([ 'Error in getUserDefinedStates', this.bindId, error ]);
      }
    });
  }

  updateComponentDisplay(): void {
    this.callMarkForCheckOnDropdown = true;
    this.changeDetectorRef.markForCheck();
  }
}
